<h1 class="appHeading">{{ title | translate }}</h1>
